<template>
  <div class="wrap">
    <h3 class="title">富裕钱包隐私政策 </h3>
    <p>
      欢迎您使用富裕钱包APP(以下简称"富裕钱包APP"或"平台")。北京付裕数字科技有限公司及其关联方（简称“我们”）作为富裕钱包APP的运营主体以及平台服务的提供方，我们非常重视用户的隐私和个人信息保护。您在使用我们的产品与/或服务时，我们将通过《富裕钱包隐私政策》(以下简称"本政策")向您说明我们在您使用我们的产品与/或服务时如何收集、使用、保存、共享和转让这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。
    </p>
    <p>
      本政策将帮助您了解以下内容：
    </p>
    <p class="">
      一．我们如何收集和使用您的个人信息
    </p>
    <p class="">
      二．我们如何使用 Cookie 和同类技术
    </p>
    <p class="">
      三．我们如何共享、转让、公开披露您的个人信息
    </p>
    <p class="">
      四．我们如何保存您的个人信息
    </p>
    <p class="">
      五．我们如何保护您的个人信息
    </p>
    <p class="">
      六．您如何管理您的个人信息
    </p>
    <p class="">七．第三方SDK收集使用信息说明</p>
    <p class="">
      八．未成年人的个人信息保护
    </p>
    <p class="">
      九．我们如何更新与修改本政策
    </p>
    <p class="">
      十．如何联系我们
    </p>
    <p class="weight">
      一．我们如何收集和使用您的个人信息
    </p>
    <p>
      我们会依据引言中所提及的相关法律法规，遵循正当、合法、必要的原则，出于本政策所述的以下目的，收集和使用您在使用富裕钱包服务过程中主动提供的、因您使用富裕钱包服务而产生的以及从第三方获取的您的个人信息。无论通过上述何种方式收集和使用您的个人信息，我们原则上只会在征得您同意的情况下进行，除非在某些情况下，基于法律义务或者可能需要保护您或其他人的重要利益向您收集个人信息，但我们不会收集法律法规禁止收集的个人信息。您可以选择不提供某一或某些信息。
      <span class="weight">如您选择不提供某一或某些信息，可能会导致您无法使用或无法正常使用部分富裕钱包服务，但这不会对您使用富裕钱包其他服务产生影响。</span>
    </p>
    <p>
      请您理解，由于商业策略的变化，富裕钱包服务的功能也可能进行更迭和发展。如果我们要将您的个人信息用于本政策未载明的其它用途，或基于特定目的将收集而来的个人信息用于其他目的的，我们会通过本平台以及平台以合理的方式(如弹窗等形式)向您告知，并在使用前再次征得您的同意。
    </p>
    <p>
      （一）我们如何收集您的信息
    </p>
    <p class="">
      为了遵守相关法律及监管规定，也为了便于您查询服务记录或历史状态，我们将您使用富裕钱包时的身份信息、服务信息、交易信息、行为日志信息进行记录存档，并严格按照法律规定对这些信息进行妥善保管。
    </p>
    <p class="">
      我们会通过如下三种渠道获取您的个人信息：
    </p>
    <p>
      1、您直接提供的信息：我们可能收集并存储您在使用富裕钱包服务时向我们提供的任何信息，包括您在我们页面中在线填写信息时、解决争议或就富裕钱包服务与我们联系时所提供的信息，以及您在使用我们服务过程中产生的关于您的交易和活动的信息。
    </p>
    <p>
      2、我们主动收集的信息：在您使用富裕钱包APP及相关服务过程中，我们会收集您的计算机、手机及其他访问设备发送给我们的信息。
    </p>
    <p class="">
      3、我们间接取得的信息：在取得您同意的前提下，我们还可能从合作伙伴及依法成立并合法留存您的相关信息的第三方机构获取您的相关信息。
    </p>
    <p>
      我们收集您信息的目的主要是为了向您提供安全、高效以及个性化的服务体验。我们会出于以下目的使用您的个人信息：
    </p>
    <p class="weight">
      1、账户注册和登录、实名认证、商户认证、银行卡管理。
    </p>
    <p>
      <1> 当您注册富裕钱包服务时，我们会收集你的手机号，收集该信息是为了帮助你完成账户注册。当您用手机号进行登录时, 我们会收集
        <span class="weight">当前设备是否
          越狱、当前设备的IP地址、当前设备的唯一标识</span>。手机号码属于敏感信息，收集此类信息是为了满足相关法律法规的网络实名制要求。若你不提供这类信息，你可能无法正常使用我们的服务。
    </p>
    <p class="">
      <2>实名认证:您在首次开通富裕钱包服务时我们需要首先认证您身份的真实性，为此您需要提供您的<span
          class="weight">真实姓名、身份证号码、身份证有效期、手机号、银行卡信息、银行卡归属地信息、身份证正反面照片、手持身份证照片、银行卡正反面照片以及用户自主签名照片</span>。
    </p>
    <p class="">
      <3>商户认证:您在首次开通富裕钱包服务时我们需要先对您所在商户的真实性进行审核,为此需要提供您的<span class="weight">商户名称、商户所在地址、商户的经营类别、商户门头照、协议照片 </span>
    </p>
    <p>
      <4>银行卡管理: 您在使用收付款功能时, 需要您提供<span class="weight">银行卡卡号、对应银行卡银行预留手机号、并同真实姓名、身份证号码</span>一起上传, 参与银行卡绑定
    </p>
    <p>
      我们会将上述信息提交给合法持有您上述信息的第三方身份验证机构，以便对您所提供信息的准确性进行核对。如果您不提供上述信息则无法使用根据中国相关法律法规必须进行实名制管理的收付款服务。
    </p>
    <p class="weight">
      2、为您提供您选择的富裕钱包相关服务
    </p>
    <p>
      平台上的收、付款服务由我们合作的第三方支付机构/银行机构或其他组织提供。当您通过富裕钱包使用收、付款服务功能时，我们会使用您的个人身份信息及其他在业务具体开展过程中基于您的同意而采集的信息对我们产品或服务进行验证交易真实性、处理产品或服务请求以及完成交易指令并向您发送交易通知等。同时，为了遵守相关法律法规及监管规定，也为了便于您查询交易记录或历史状态，我们会将您使用富裕钱包服务时的
      <span
        class="weight">身份信息，包含真实姓名、身份号码、身份证有效期以及身份证正反面和手持身份证照片、交易信息及行为信息，包含用户真实姓名、身份证号码、身份证有效期、身份证正反面照片、手持身份证照片、银行卡信息、银行卡正反面、银行卡对应预留手机号、用户自主签名、短信码、定位信息</span>进行存档，并严格按照法律法规的规定对这些信息进行妥善保管。
    </p>
    <p class="weight">
      3、提供客户服务及进行投诉处理
    </p>
    <p class="">
      我们的客服系统会使用您的<span
        class="weight">账号信息和交易信息，包含真实姓名、身份号码、银行卡信息、手机号、定位信息</span>。为保证您的账号安全，我们的呼叫中心客服和在线客服会使用您的账号信息列举完全与您核验您的身份。当您需要我们提供与您交易信息相关的客服与售后服务时，我们将会查询您的交易信息。
    </p>
    <p class="">
      为了保证您及他人的合法权益，如您被他人投诉或投诉他人，我们会将您的<span
        class="weight">真实姓名及身份证号码、</span>投诉相关内容提供给消费者权益保护部门及监管机关，以便及时解决投诉纠纷，但法律法规明确禁止提供的除外。
    </p>
    <p class="weight">
      4、保障交易安全所必须的功能
    </p>
    <p class="">
      为提高您使用我们的产品与/或服务时系统的安全性，更准确地预防钓鱼网站欺诈和保护账户安全，<span
        class="weight">我们可能会通过了解您的交易信息、设备信息（是否频繁在多个地方定位以及当前设备是否经常切换，是否越狱）等手段来判断您的账号风险，</span>并可能会记录一些我们认为有风险的链接（“URL”）；我们也会收集您的设备信息对于平台系统问题进行分析、统计流量并排查可能存在的风险、在您选择向我们发送异常信息时予以排查。
    </p>
    <p class="weight">
      5、设备权限调用说明
    </p>
    <p class="">
      各相关业务功能可能开启您的设备访问权限的逐项列举，详见下表：
    </p>
    <table border="1" style="margin: 10px 0;">
      <tr>
        <th>设备权限</th>
        <th>业务功能</th>
        <th>权限授予方式</th>
      </tr>
      <tr>
        <td>无线网络</td>
        <td>各项业务功能进行网络连接</td>
        <td>用户首次打开富裕钱包APP时弹窗询问</td>
      </tr>
      <tr>
        <td>相机</td>
        <td>扫码、实名认证等</td>
        <td>用户首次使用相关业务功能时弹窗询问</td>
      </tr>
      <tr>
        <td>访问存储卡/照片</td>
        <td>实名认证、保存照片等</td>
        <td>用户首次使用相关业务功能时弹窗询问</td>
      </tr>
      <tr>
        <td>定位权限</td>
        <td>登录和交易时记录地理定位</td>
        <td>用户首次打开富裕钱包APP时弹窗询问</td>
      </tr>
      <tr>
        <td>手机状态权限</td>
        <td>获取设备唯一标识</td>
        <td>首次登录APP时弹窗询问</td>
      </tr>
      <tr>
        <td>应用列表权限</td>
        <td>通过当前APP包名读取当前APP名称用于显示退出时提示语</td>
        <td>无需授权</td>
      </tr>
    </table>
    <p class="">
      您确认并同意开启这些权限即代表您授权我们可以收集和使用相关信息来实现特定业务功能；您也可以遵循本政策第六节"(三)改变您授权同意的范围"提示的方法关闭或者变更这些授权，则我们将不再继续收集和使用您的这些信息，也无法为您提供上述与这些授权所对应的功能，但这不会对您使用富裕钱包的其他服务产生影响。
    </p>
    <p class="">
      6、您充分知晓，以下情形中，我们收集、使用个人信息无需征得您的授权同
    </p>
    <p class="">
      （1）与国家安全、国防安全有关的；
    </p>
    <p class="">
      （2）与公共安全、公共卫生、重大公共利益有关的；
    </p>
    <p class="">
      （3）与犯罪侦查、起诉、审判和判决执行等有关的；
    </p>
    <p>
      （4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
    </p>
    <p>
      （5）所收集的个人信息是个人信息主体自行向社会公众公开的；
    </p>
    <p class="">
      （6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；
    </p>
    <p>
      （7）根据您的要求签订合同所必需的；
    </p>
    <p>
      （8）用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置服务的故障；
    </p>
    <p class="">
      （9）为合法的新闻报道所必需的；
    </p>
    <p>
      （10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
    </p>
    <p class="">
      （11）法律法规规定的其他情形。
    </p>
    <p>
      7、您个人信息使用的规则
    </p>
    <p class="">
      （1）我们会根据本隐私政策的约定并为实现我们的产品与/或服务功能对所收集的个人信息进行使用。
    </p>
    <p class="">
      （2）请您注意，您在使用我们的产品与/或服务时所提供的所有个人信息，除非您删除或通过系统设置拒绝我们收集，否则将在您使用我们的产品与/或服务期间持续授权我们使用。在您注销账号时，我们将停止使用并按照相关法律法规的要求删除您的个人信息或进行匿名化处理。
    </p>
    <p class="">
      （3）我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全。
    </p>
    <p class="">
      （4）当我们要将您的个人信息用于本政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。
    </p>
    <p class="weight">
      二．我们如何使用Cookie和同类技术
    </p>
    <p>
      您使用我们的服务时，为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie
      通常包含标识符、站点名称以及一些号码和字符。Cookie主要的功能是便于您使用平台产品和／或服务，以及帮助网站统计独立访客数量等。运用Cookie技术，我们能够为您提供更加周到的个性化服务，并允许您设定您特定的服务选项。
    </p>
    <p class="">
      当您使用平台产品和／或服务时，会向您的设备发送Cookie。当您与我们提供给合作方的服务(例如广告和/或推广服务，以及可能显示在其他网站上的由富裕钱包提供的服务功能)进行交互时，我们允许Cookie(或者其他匿名标识符)发送给我们的服务器。
    </p>
    <p>
      我们不会将Cookie用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置，您可能因为该等修改，无法登录或使用依赖于Cookie的富裕钱包提供的服务或功能。
    </p>
    <p class="">
      除Cookie外，我们可能还会在网站上使用网络Beacon等其他同类技术来访问您的数据。请您理解，当您通过平台访问第三方创建的网页时，这些第三方可能通过自己的Cookie、Web
      Beacon收集您的信息。该等行为不受我们控制及本政策的约束，而是受该第三方隐私政策约束。我们建议您在使用第三方提供的服务前，仔细阅读该等第三方隐私政策的内容。我们也会履行必要的审核义务，并努力去要求第三方对您的个人信息采取保护措施。
    </p>
    <p class="weight">
      三．我们如何共享、转让、公开披露您的个人信息
    </p>
    <p>
      为了优化我们的服务质量，当您通过富裕钱包APP购买相关产品和/或服务时，我们可能会将您的个人信息提供给我们合作的清算组织、银行机构、第三方支付机构或其他组织，由该等服务提供商向您提供支付服务。
    </p>
    <p>
      目前，您在使用产品和/或服务时的必要的个人信息共享如下：
    </p>
    <p>
      <span class="weight">-提供收付款服务的合作方。</span>为了向您提供付款服务，完成交易结算，我们需要将您提供的银行卡信息、姓名、身份证号码、银行预留手机号、交易编号、交易时间、交易金额、交易对象等必要结算所需信息通过后台接口传输方式提供给支付清算机构、发生交易对应对的商户和您选择的支付方式所对应的支付机构。
    </p>
    <p>
      为了向您提供收款服务，完成交易结算，我们需要将您提供的收款账号、收款人姓名、收款金额等必要收款信息，以及付款信息等必要信息通过后台接口传输方式提供给支付清算机构和您所选择的支付方式所对应的支付机构。
    </p>
    <p>
      <span class="weight">-提供增值业务的服务方。</span>为了向您提供网申办卡等增值业务，我们需要将您提供的姓名、身份证号码、手机号、交易编号、交易时间等必要信息通过后台接口传输方式提供给您选择的服务所对应的金融机构。
    </p>
    <p>
      <span class="weight">-提供第三方代码、插件的服务方。</span>为了便于您正常使用富裕钱包APP、保障您的账号及网络安全并持续优化我们的服务质量，我们还将与提供第三方代码、插件的服务方合作，这些服务方会通过富裕钱包APP向您收集必要的信息。
    </p>
    <p>
      四．我们如何保存您的个人信息
    </p>
    <p class="weight">
      为了遵守法律法规与监管要求，同时为了便于您查询相关的交易记录等个人信息，我们将保存您在申请或使用富裕钱包服务过程中提供、产生的必要信息。我们将采取物理或逻辑隔离机制对您的一般个人信息与个人敏感信息分开存储。涉及个人敏感信息的，我们会采用加密等安全措施予以特殊保护。
    </p>
    <p class="weight">
      （一）存储地域
    </p>
    <p>
      <span
        class="weight">我们在中国境内收集和产生的您的个人信息将储存于中国境内。如未来部分服务涉及跨境业务，需要向境外机构传输您的个人信息的，我们会按照法律法规和相关监管部门的规定执行，事先开展安全评估，向您告知出境的目的、涉及的个人信息类型、接收方的身份和数据安全能力及可能存在的安全风险且征得您的同意，并通过签订协议、监督核查、安全审计等有效措施明确各方义务和责任，要求境外机构为所获得的个人信息保密。</span>
    </p>
    <p>
      （二）存储期限
    </p>
    <p>
      <span class="weight">除非法律法规另有规定，我们将在实现本政策所述目的的最短必要期限内保留您的个人信息。</span>当您的个人信息超出我们所保存的期限后，我们会对您的个人信息进行删除或匿名化处理。
    </p>
    <p>
      五．我们如何保护您的个人信息
    </p>
    <p>
      您的个人信息安全对于我们至关重要。我们将严格遵守相关法律法规，采取业内认可的合理可行的安全措施，保护您的个人信息。防止信息遭到未经授权的访问、披露、使用、修改，避免信息损坏或丢失。
    </p>
    <p class="weight">
      （一）技术措施与数据安全措施
    </p>
    <p>
      1.我们努力采取各种符合业界标准的物理、电子和管理方面的安全措施来保护您的个人信息安全，如：SSL/应用层加密技术、HTTPS双向认证技术、数字签名、SHA256脱敏技术等，以防止个人信息在收集、存储、传输等过程中遭到泄露、破坏，并通过用户协议和本政策告知您相关信息的使用目的和范围。
    </p>
    <p>
      2.我们积极建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用，确保未收集与我们提供的服务无关的个人信息。
    </p>
    <p>
      3.我们会对员工进行数据安全的意识培养和安全能力的培训和考核，加强员工对于保护个人信息重要性的认识。我们会部署访问控制机制，对处理个人信息的员工进行身份认证及权限控制。我们会与信息接触者、合作机构签署保密协议，明确岗位职责及行为准则，确保只有授权人员才可访问个人信息。若有违反保密协议的行为，会被追究相关责任。我们也会通过监控和审计机制来对数据进行全面安全控制，履行个人信息访问权限审批与控制措施，防止您的个人信息遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。
    </p>
    <p>
      4.我们会定期进行数据安全能力评估/信息安全风险评估，确保安全保护系统始终处于完备状态。
    </p>
    <p>
      5.我们成立了专职团队负责研发和应用多种安全技术和程序等，我们会对安全管理负责人和关键安全岗位的人员进行安全背景审查，我们建立了完善的信息安全管理制度和内部安全事件处置机制等。我们会采取符合业界标准的合理可行的安全措施和技术手段存储和保护您的个人信息，以防止您的信息丢失、遭到被未经授权的访问、公开披露、使用、修改、毁损、丢失或泄漏。我们会采取一切合理可行的措施，保护您的个人信息。我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击。
    </p>
    <p>
      6.我们提醒您注意，互联网并非绝对安全的环境，当您通过电子邮件、短信等与其他用户交互信息时，不确定第三方软件对信息的传递是否完全加密，请注意确保您个人信息的安全，我们建议您不要通过此类方式发送个人信息，以免个人信息泄露。请使用复杂密码，协助我们保证您的账户以及个人信息安全。
    </p>
    <p class="weight">
      （二）安全事件处置
    </p>
    <p>
      1.我们将尽力确保您发送给我们的任何信息的安全性，但请您理解，由于技术的限制以及在互联网行业可能存在的各种恶意手段，不可能始终保证信息百分之百的安全。您需要了解，您接入我们服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。为防止安全事故的发生，我们会制定网络安全事件应急预案，及时处置系统漏洞、计算机病毒、网络攻击、网络侵入等安全风险，在发生危害网络安全的事件时，我们会立即启动应急预案，采取相应的补救措施，力求将损失最小化，并按照规定向有关主管部门报告。
    </p>
    <p>
      2.个人信息泄露、毁损、丢失属于公司级特大安全事件，我们会负责定期组织工作组成员进行安全预案演练，防止此类安全事件发生。若一旦不幸发生，我们将按照最高优先级启动应急预案，由安全部、政府关系部、法务部等多个部门组成应急响应小组，在最短时间内追溯原因并减少损失。
    </p>
    <p>
      3.在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、您可自主防范和降低的风险的建议和对您的补救措施等。我们将及时将事件相关情况以站内通知、短信通知、电话、邮件等您预留的联系方式告知您，难以逐一告知时我们会采取合理、有效的方式发布公告。
    </p>
    <p>
      4.同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况，紧密配合政府机关的工作。如我们未能有效履行个人信息安全保护义务的，导致您的合法权益受损，我们将承担相应的责任。
    </p>
    <p class="weight">
      六．您如何管理您的个人信息
    </p>
    <p class="weight">
      富裕钱包非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：
    </p>
    <p>
      （一）访问和更正您的个人信息
    </p>
    <p>
      您有权访问您的个人信息，法律法规规定的例外情况除外。您可以在富裕钱包APP上通过以下方式自行访问和更正您的个人信息：
    </p>
    <p>
      1.您可以通过【我→银行卡管理】，访问/更正您的银行卡信息；
    </p>
    <p>
      2.您可以通过【我→更多→密码修改】，访问/修改您的登录密码；
    </p>
    <p>
      3.您可以通过【我→更多→安全保障】，访问/修改您的支付密码；
    </p>
    <p>
      4.您可以通过【我→交易明细】，访问您的历史收付款交易记录；
    </p>
    <p>
      5.您可以通过【我→实名认证】，访问/修改您的姓名、手机号、身份证号、身份证件有效期及结算卡；
    </p>
    <p>
      6.您可以通过【我→商户认证】，访问/管理您的商户资料信息
    </p>
    <p>
      7.对于您在使用我们的产品与/或服务过程中产生的其他个人信息需要访问或更正，请随时联系我们。我们会根据本隐私政策所列明的方式和期限响应您的请求。
    </p>
    <p>
      8.您无法访问和/或更正的个人信息：除上述列明的信息外，您的部分个人信息我们还无法为您提供访问和/或更正的服务，这些信息主要是为了保证交易安全满足相关强制性法律法规要求所收集的您的设备信息、您使用富裕钱包服务时产生的个人信息。上述信息我们会在您的授权范围内按照相关法律法规的规定进行使用，您无法变更或自主删除。
    </p>
    <p>
      （二）删除您的个人信息
    </p>
    <p>
      您在我们的产品与/或服务页面中可以直接清除或删除的信息，包括绑定银行卡、浏览记录、收藏记录、关注记录等。
    </p>
    <p class="weight">
      在以下情形中，您可以向我们提出删除个人信息的请求：
    </p>
    <p>
      （1）如果我们处理个人信息的行为违反法律法规；
    </p>
    <p>
      （2）如果我们收集、使用您的个人信息，却未征得您的同意；
    </p>
    <p>
      （3）如果我们处理个人信息的行为违反了与您的约定；
    </p>
    <p>
      （4）如果您注销富裕钱包账户；
    </p>
    <p>
      （5）如果我们终止服务及运营。
    </p>
    <p>
      若我们决定响应您的删除请求，我们会根据您的要求及相关法律法规的要求进行后续删除处理并向您进行结果反馈。
    </p>
    <p>
      （三）改变您授权同意的范围或撤回您的授权
    </p>
    <p class="weight decor">
      您可以通过删除信息、关闭设备功能等方式改变部分您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。
    </p>
    <p class="weight decor">
      请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。
    </p>
    <p>
      （四）注销
    </p>
    <p class="weight decor">
      您可以在我们的产品与/或服务中直接申请注销账户或注销您申请的具体富裕钱包服务功能。关于您注销账户的方式以及您应满足的条件您可以通过本协议下方的方式与我们联系来获取。您注销账户后，我们将停止为您提供产品与/或服务，并依据您及相关法律法规的要求处理您的个人信息。
    </p>
    <p>
      （五）响应您的请求
    </p>
    <p>
      如果您无法通过上述方式访问、更正或删除您的个人信息，或您需要访问、更正或删除您在使用我们产品与/或服务时所产生的其他个人信息，或您认为富裕钱包存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您均可以发送电子邮件至operate@verajft.com或通过本协议下方的其他方式与我们联系。为了保障安全，我们可能需要您提供书面请求，或以其他方式证明您的身份，我们将在收到您反馈并验证您的身份后的30天内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
    </p>
    <p>
      在以下情形中，按照法律法规要求，我们将无法响应您的请求：
    </p>
    <p>
      （1）与国家安全、国防安全有关的；
    </p>
    <p>
      （2）与公共安全、公共卫生、重大公共利益有关的；
    </p>
    <p>
      （3）与犯罪侦查、起诉和审判等有关的；
    </p>
    <p>
      （4）有充分证据表明您存在主观恶意或滥用权利的；
    </p>
    <p>
      （5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。
    </p>
    <p class="weight">
      七．第三方SDK收集使用信息说明
    </p>
    <p>
      Android端所集成的第三方SDK名称、SDK收集使用的个人信息以及使用目的
    </p>
    <table border="1" style="margin: 10px 0;">
      <tr>
        <th>第三方SDK名称</th>
        <th>收集使用信息</th>
        <th>使用目的</th>
      </tr>
      <tr>
        <td>支付宝sdk</td>
        <td>交易编号</td>
        <td>用于支付时调用支付</td>
      </tr>
      <tr>
        <td>刷脸sdk</td>
        <td>人脸照片</td>
        <td>识别面部信息，用于支付安全认证</td>
      </tr>
      <tr>
        <td>ocr sdk</td>
        <td>身份证照片、银行卡照片、营业执照照片</td>
        <td>便于用户实名认证免输入拍照快速识别文字</td>
      </tr>
      <tr>
        <td>银联安全控件sdk</td>
        <td>
          1.商户编号<br/>
          2.订单号<br/>
          3.订单创建时间<br/>
          4.交易金额<br/>
          5.设备标识<br/>
          6.位置信息<br/>
        </td>
        <td>支付环境安全检侧及保护，以及便于用户手机刷卡支付</td>
      </tr>
      <tr>
        <td>友盟统计sdk</td>
        <td>
          1.设备唯一设备识别码<br/>
          2.位置信息<br/>
          3.获取wifi mac地址<br/>
        </td>
        <td>用于APP分析服务及错误信息统计</td>
      </tr>
      <tr>
        <td>个推SDK</td>
        <td>
          1.设备唯一设备识别码<br/>
          2.网络信息以及位置<br/>
        </td>
        <td>用于消息推送</td>
      </tr>
      <tr>
        <td>腾讯Bugly SDK</td>
        <td>
          1.获取手机型号<br/>
          2.获取APP版本号<br/>
        </td>
        <td>用于APP版本升级</td>
      </tr>
      <tr>
        <td>thinker SDK</td>
        <td>
          1.获取手机型号<br/>
          2.获取APP版本号<br/>
        </td>
        <td>用于APP版本升级</td>
      </tr>
      <tr>
        <td>update-app SDK</td>
        <td>
          1.获取手机型号<br/>
          2.获取APP版本号<br/>
        </td>
        <td>用于APP版本升级</td>
      </tr>
      <tr>
        <td>walle SDK</td>
        <td>APP版本信息</td>
        <td>用于多渠道打包</td>
      </tr>
      <tr>
        <td>leakcanary SDK</td>
        <td>APP内存信息</td>
        <td>用于分析内存泄漏情况</td>
      </tr>
      <tr>
        <td>XXPermissions SDK</td>
        <td>获取需要的权限</td>
        <td>用于动态申请权限</td>
      </tr>
      <tr>
        <td>微信分享SDK</td>
        <td>无</td>
        <td>用于分享图片与链接到微信</td>
      </tr>
      <tr>
        <td>jiecaovideoplayer SDK</td>
        <td>无</td>
        <td>用于播放视频教程</td>
      </tr>
      <tr>
        <td>zxing SDK</td>
        <td>无</td>
        <td>用于识别二维码</td>
      </tr>
    </table>
    <p class="weight">
      八．未成年人的个人信息保护
    </p>
    <p>
      1、富裕钱包非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的产品与/或服务前，应事先取得您家长或法定监护人的同意。富裕钱包根据国家相关法律法规的规定保护未成年人的个人信息。
    </p>
    <p>
      2、对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。
    </p>
    <p>
      3、如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。
    </p>
    <p>
      九．我们如何更新与修改本政策
    </p>
    <p>
      为了给您提供更好的服务以及业务发展的需要，我们保留适时更新本政策的权利。未经您明确同意，我们不会削减您在本政策项下应享有的权利。如本政策发生更新，我们会在富裕钱包APP端及时更新，并通过合理方式(包括但不限于弹窗提示、在页面显著位置提示、APP推送通知、向您发送电子邮件/短消息等方式)通知您，以便您能及时了解本政策所做的任何变更。
    </p>
    <p>
      对于重大变更，视具体情况我们可能还会提供更为显著的通知说明本政策具体变更内容。<span
        class="weight">请您注意，只有在您重新授权后，我们才会按照更新后的隐私政策收集、使用、共享、保存您的个人信息。重大变更包括但不限于：</span>
    </p>
    <p>
      1.我们的服务模式和业务形态发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
    </p>
    <p>
      2.我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
    </p>
    <p>
      3.个人信息共享、转让或公开披露的主要对象发生变化；
    </p>
    <p>
      4.您参与个人信息处理方面的权利及其行使方式发生重大变化；
    </p>
    <p>
      5.我们负责处理个人信息安全的联络方式及投诉渠道发生变化；
    </p>
    <p>
      6.个人信息安全影响评估报告表明存在高风险时。
    </p>
    <p>
      如果您在本政策更新后继续使用富裕钱包服务，则视为您已充分阅读并接受本政策相关条款的修改。如本政策的条款与平台采用的任何服务协议中规定的隐私权保护及授权条款存在不一致或冲突之处，应当以本政策的相关条款为准。
    </p>
    <p class="weight">
      十．如何联系我们
    </p>
    <p>
      我们设立了专职个人信息保护负责人和个人信息保护工作机构，个人信息保护负责人的联系方式为400 690
      6089。如您在使用富裕钱包APP时就您的个人信息的收集、使用、共享、保存等事宜有任何困惑，或您对本政策有任何意见或建议，甚至因本政策产生任何争议的，可通过上述邮箱地址、客服电话010-64911789或点击【我→更多→关于我们】等多种方式联系我们，我们将安排专员及时为您提供咨询或协调解决您投诉、申诉的问题。
    </p>
    <p>
      除法律法规要求外，我们将在十五个工作日内回复。
    </p>
    <p>
      为保障我们高效处理您的问题并及时向您反馈，部分情况下我们可能会要求您提交身份证明、有效联系方式和书面请求及相关证据，我们会在验证您的身份后处理您的请求。
    </p>
    <p>
      如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过以下外部途径寻求解决方案<span
        class="weight">：向北京市海淀区人民法院提起诉讼，您也可向有关政府部门或者行业协会进行反映。</span>
    </p>
    <p class="weight">
      附录1：关键词定义
    </p>
    <p>
      本政策中使用的特定词语，具有如下含义：
    </p>
    <p>
      1.个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。个人信息包括个人基本信息、个人身份信息、个人生物识别信息、网络身份标识信息、个人健康生理信息、个人教育工作信息、个人财产信息、个人通信信息、联系人信息、个人上网记录、个人常用设备信息、个人位置信息等。为免疑义，个人信息包括但不限于个人敏感信息。
    </p>
    <p>
      2.个人信息主体：指个人信息所标识的自然人。
    </p>
    <p>
      3.个人敏感信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。个人敏感信息包括个人财产信息、个人健康生理信息、个人生物识别信息、个人身份信息、网络身份标识信息等。为了帮助您更好地理解个人敏感信息类型，我们依据GB/T
      35273-2017《信息安全技术个人信息安全规范》将个人敏感信息示例如下，但不代表我们所收集的全部个人敏感信息：
    </p>
    <table style="width: 100%;" border="1">
      <tr>
        <td style="width: 30%;">个人财产信息</td>
        <td>银行账号、鉴别信息(口令)、存款信息(包括资金数量、支付收款记录等)、房产信息、信贷记录、征信信息、交易和消费记录、流水记录等，以及虚拟货币、虚拟交易、游戏类兑换码等虚拟财产信息</td>
      </tr>
      <tr>
        <td style="width: 40%;">个人健康生理信息</td>
        <td>个人因生病医治等产生的相关记录、如病症、住院志、医嘱单、检验报告、手术及麻醉记录、护理记录、用药记录、药物食物过敏信息、生育信息、以往病史、诊治情况、家族病史、现病史、传染病史等，以及与个人身体健康状况产生的相关信息</td>
      </tr>
      <tr>
        <td style="width: 40%;">个人生物识别信息</td>
        <td>个人基因、指纹、声纹、掌纹、耳廓，虹膜、面部识别特征等</td>
      </tr>
      <tr>
        <td style="width: 40%;">个人身份信息</td>
        <td>身份证、军官证、护照、驾照、工作证、社保卡、居住证等</td>
      </tr>
      <tr>
        <td style="width: 40%;">网络身份标识信息</td>
        <td>系统账号、邮箱地址及与前述有关的密码、口令、口令保护答案、用户个人数字证书等</td>
      </tr>
      <tr>
        <td style="width: 40%;">其他信息</td>
        <td>个人电话号码、性取向、婚史、宗教信仰、未公开的违法犯罪记录、通信记录和内容、行踪轨迹、网页浏览记录、住宿信息、精准定位信息等</td>
      </tr>
    </table>
    <p>
      4.设备信息：设备信息可分为设备属性信息、设备位置信息与设备连接信息。设备属性信息是指用户使用终端设备访问富裕钱包平台时的设备品牌及型号、设备屏幕规格、操作系统版本、设备设置、唯一设备识别符等软硬件特征。设备位置信息是指通过用户使用的终端设备获取用户访问富裕钱包平台时所处的地理位置信息，如通过GPS、蓝牙或WiFi信号获得的位置信息。设备连接信息是指用户使用终端设备访问富裕钱包平台所显示的IP地址、浏览器的类型、电信运营商、适用的语言、访问日期和时间信息。
    </p>
    <p>
      5.去标识化：指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体的过程。
    </p>
    <p>
      6.匿名化：指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。
    </p>
    <p>
      7.中国境内：指中华人民共和国大陆地区，仅为本政策之目的，不包含香港特别行政区、澳门特别行政区和台湾地区。
    </p>
    <p>生效日期：2021-8-31</p>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        entryMode: "" //判断是怎么进来的
      }
    },
    methods: {
      back() {
        this.$router.push({
          name: "share",
          query: {
            isBack: "0000"
          }
        })
      }
    },
    created() {
      document.title = "隐私政策"
    },

  }
</script>

<style scoped>
  .wrap {
    padding: 0 10px;
  }

  .title {
    text-align: center;
    padding: 10px 0;
  }

  .weight {
    font-weight: bold;
  }

  p {
    line-height: 30px;
  }

  .subTitle {
    line-height: 28px;
    margin-top: 10px;
  }

  .pic {
    position: fixed;
    left: 0;
    bottom: 40%;
    opacity: .7;
  }

  table {
    width: 100%;
    border-spacing: 0;
  }

  .decor {
    text-decoration: underline;
  }
</style>